
import * as angular from "angular";

import "./veriPage.scss";

interface IVeriPageBindings {
    pageTitle: string;
}

export class VeriPageComponentController implements angular.IComponentController, IVeriPageBindings {

    pageTitle: string = "unset";

    static $inject = [];
}

export class VeriPageComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean | { [index: string]: string; };

    constructor() {
        this.bindings = {
            pageTitle: "@"
        };

        this.controller = VeriPageComponentController;
        this.template = require("./veriPage.html");
        this.transclude = true;
    }
}
